import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "cmp-ciam-login"
};
const _hoisted_2 = {
  class: "login-body"
};
const _hoisted_3 = {
  key: 0,
  class: "error-message"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 1,
  class: "error-message"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 2,
  class: "error-message"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  key: 3,
  class: "error-message"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  key: 4,
  class: "redirecting-message"
};
const _hoisted_12 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingDots = _resolveComponent("LoadingDots");
  const _component_DcAlert = _resolveComponent("DcAlert");
  const _component_ConfirmRegistration = _resolveComponent("ConfirmRegistration");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_LoadingDots, {
    loading: $options.loading
  }, null, 8, ["loading"]), $data.showError ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_createVNode(_component_DcAlert, {
    type: "error"
  }, {
    message: _withCtx(() => [_createElementVNode("p", {
      innerHTML: $options.getLabel('login.generic.error')
    }, null, 8, _hoisted_4)]),
    _: 1
  })])) : $data.showInternalError ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_DcAlert, {
    type: "error"
  }, {
    message: _withCtx(() => [_createElementVNode("p", {
      innerHTML: $options.getLabel('internal.user.not.found')
    }, null, 8, _hoisted_6)]),
    _: 1
  })])) : $data.showExternalError ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_createVNode(_component_DcAlert, {
    type: "error"
  }, {
    message: _withCtx(() => [_createElementVNode("p", {
      innerHTML: $options.getExternalLabel('external.user.not.found')
    }, null, 8, _hoisted_8)]),
    _: 1
  })])) : $options.userLoggedOut ? (_openBlock(), _createElementBlock("span", _hoisted_9, [_createVNode(_component_DcAlert, {
    type: "warning"
  }, {
    message: _withCtx(() => [_createElementVNode("p", {
      innerHTML: $options.getLabel('timeout.login.notification.message')
    }, null, 8, _hoisted_10)]),
    _: 1
  })])) : !$data.showError && !$data.hideRedirect ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($options.getLabel('login.redirectionMessage')), 1)) : _createCommentVNode("", true), !$options.loading && $data.hideRedirect ? (_openBlock(), _createElementBlock("button", {
    key: 5,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.loginClick && $options.loginClick(...args)),
    type: "submit",
    class: "btn",
    disabled: $options.loading || !$data.hideRedirect
  }, _toDisplayString($options.getLabel('button.login.Title')), 9, _hoisted_12)) : _createCommentVNode("", true)]), $options.reauthorizationRequired ? (_openBlock(), _createBlock(_component_ConfirmRegistration, {
    key: 0
  })) : _createCommentVNode("", true)]);
}